// extracted by mini-css-extract-plugin
module.exports = {"bookingItem":"CalendarView_bookingItem__4tcb2","pending":"CalendarView_pending__rzMhi"};